<div class="slidepop"  [ngClass]="{'open': showSidePanel}" >

  
    <div *ngIf="showcreateForm">
      <app-create-permissions  (closeSidePanel)="closeSidePanel($event)" [ngClass]="{ open: showcreateForm }" ></app-create-permissions>
    </div>
    <div *ngIf="showeditForm">
      <app-edit-permissions (closeSidePanel)="closeSidePanel($event)" [ngClass]="{ open: showeditForm }" ></app-edit-permissions>
    </div> 

</div>

<!-- <div class="slidepop"  [ngClass]="{'open': showSidePanel}" >
 
  <div *ngIf="showcreateForm">
    <app-role-detailss (closeSidePanel)="closeSidePanel($event)" [ngClass]="{ open: showcreateForm }"> </app-role-detailss>
  </div>

  <div *ngIf="showeditForm">
    <app-edit-roles (closeSidePanel)="closeSidePanel($event)" [ngClass]="{ open: showeditForm }"></app-edit-roles>
  </div>  

</div> -->

<div class="" fxLayout="column" fxLayoutAlign="start">
    <mat-card class="filter">
        <div class="sort_layout" fxLayout="row" fxLayoutAlign="start center">
          <h3>Permissions</h3>
        </div>
    
        <div class="actbtn"  *ngIf="showAdd == true">
          <button mat-flat-button color="primary" (click)="addPermissions()">
            Create Permission
          </button>
        </div>
      </mat-card>
         
      <div class="content-card">
        <app-table id="SDSAppTable"
                    [downloadFileName]="'PremissionList'" [totalCount]="totalCount"
                    [pageIndex]="pageIndex" [pageSize]="pageSize" [modulename]="Module"
                    [displayedColumns]="sendDisplayedColumns" [showColumnNames]="showColumnNames"
                    [targetList]="permissionList" [clickableColumns]="clickableColumns"
                    (editObject)="openEditDialogData($event)" (pageChangeEvent)=CallNextPrevPageData($event)
                    (exportToExcel)="exportAsXLSX()">
                </app-table>
    </div> 

   



</div>


